export default "__VITE_ASSET__bc9e3058__"